import { createContext, Dispatch, SetStateAction } from 'react';

import { IGeladaProject, IGeladaOrganisation } from '@netfront/gelada-identity-library';

import { IProjectConfiguration } from '../../interfaces';

export interface ICachingEntitiesContext {
  cmsBaseUrl: string | undefined;
  isProjectConfigurationLoading: boolean;
  organisation: IGeladaOrganisation | undefined;
  project: IGeladaProject | undefined;
  projectConfiguration: IProjectConfiguration | undefined;
  setProjectConfiguration: Dispatch<SetStateAction<IProjectConfiguration | undefined>>;
}

export const CachingEntitiesContext = createContext<ICachingEntitiesContext>({
  cmsBaseUrl: undefined,
  organisation: undefined,
  project: undefined,
  isProjectConfigurationLoading: false,
  projectConfiguration: undefined,
  setProjectConfiguration: () => undefined,
});

// eslint-disable-next-line import/no-default-export
export default CachingEntitiesContext;
